<script>
  /** @type {string} */
  export let icon;

  /** @type {string?} */
  export let additionalClasses = null;
</script>

<i class="fa-solid fa-{icon} {additionalClasses}"></i>
